export default "__VITE_ASSET__CqBZyriz__"